module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'slider' || _vm.name === 'banner') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [(_vm.type == 'wxapp') ? [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "圆角图片"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.rounded),
      callback: function($$v) {
        _vm.$set(_vm.config, "rounded", $$v)
      },
      expression: "config.rounded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片间隔"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.padded),
      callback: function($$v) {
        _vm.$set(_vm.config, "padded", $$v)
      },
      expression: "config.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指示点样式"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "点",
      "inactive-text": "数字",
      "active-color": "#27cc6a",
      "inactive-color": "#ffa100"
    },
    model: {
      value: (_vm.config.dot),
      callback: function($$v) {
        _vm.$set(_vm.config, "dot", $$v)
      },
      expression: "config.dot"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指示点覆盖"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.dotCover),
      callback: function($$v) {
        _vm.$set(_vm.config, "dotCover", $$v)
      },
      expression: "config.dotCover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指示点位置"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.config.dotLocation),
      callback: function($$v) {
        _vm.$set(_vm.config, "dotLocation", $$v)
      },
      expression: "config.dotLocation"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "left"
    }
  }, [_vm._v("居左")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "center"
    }
  }, [_vm._v("居中")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "right"
    }
  }, [_vm._v("居右")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指示点形状"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.config.shape),
      callback: function($$v) {
        _vm.$set(_vm.config, "shape", $$v)
      },
      expression: "config.shape"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "circle"
    }
  }, [_vm._v("圆形")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "rectangle"
    }
  }, [_vm._v("长方型")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指示点颜色"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.config.dotColor),
      callback: function($$v) {
        _vm.$set(_vm.config, "dotColor", $$v)
      },
      expression: "config.dotColor"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "dark"
    }
  }, [_vm._v("深色")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "light"
    }
  }, [_vm._v("亮色")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "轮播项间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.padded),
      callback: function($$v) {
        _vm.$set(_vm.config, "padded", $$v)
      },
      expression: "config.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启图片描述"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.content),
      callback: function($$v) {
        _vm.$set(_vm.config, "content", $$v)
      },
      expression: "config.content"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "轮播项"
    }
  }, [_c('draggable', {
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item slider"
    }, [_c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })]), _vm._v(" "), (_vm.type === 'wxapp') ? [(item.imgUrl) ? _c('img', {
      staticClass: "banner-uploader",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }) : _c('div', {
      staticClass: "banner-uploader",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-camera"
    }), _vm._v("\n              上传图片\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "uploader-setting"
    }, [(_vm.config.content) ? _c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": "文字描述"
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }, [(item.id) ? _c('div', {
      staticClass: "link-content"
    }, [(item.linkPage === 'goods') ? [_vm._v("商品：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'category') ? [_vm._v("分类：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'article') ? [_vm._v("文章：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'planting') ? [_vm._v("软文：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'link') ? [_vm._v("页面：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'marketing') ? [_vm._v("营销：")] : _vm._e(), _vm._v("\n                  " + _vm._s(item.title) + "\n                ")], 2) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }), _vm._v("设置路径")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.type === 'pc') ? [(item.url) ? _c('img', {
      staticClass: "banner-uploader",
      attrs: {
        "src": item.url
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }) : _c('div', {
      staticClass: "banner-uploader",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-camera"
    }), _vm._v("\n              上传图片\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "uploader-setting"
    }, [(_vm.config.content) ? _c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": "文字描述"
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }, [(item.goodsId) ? _c('div', {
      staticClass: "link-content"
    }, [_vm._v("\n                  商品：" + _vm._s(item.title) + "\n                ")]) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }), _vm._v("设置路径")])])], 1)] : _vm._e()], 2)
  }), 0)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）")]), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-plus-circle banner-button-uploader",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" 添加轮播图")])], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a3776740", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3776740"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/slider.vue
// module id = 2895
// module chunks = 0